import Accordion from 'accordion-js';

export default {
  init() {
    // JavaScript to be fired on the home page
    // var img = $('.initiative__image').attr('data-id');

    // Accordions
    new Accordion('.initiative__sections', {
        showItem     : true,
        elementClass : 'initiative__section',
        questionClass: 'initiative__title',
        answerClass  : 'initiative__body',
        onToggle     : function(currentElement) {
            var id = currentElement.id;
            $('.initiative__image, .background-overlay__image').removeClass('is-active');
            $('.initiative__image[data-id="' + id + '"]').toggleClass('is-active');
            $('.background-overlay__image[data-id="' + id + '"]').toggleClass('is-active');
        },
    });

    var $initiativeImageColumn = $('.initiatives__column .lg-60');
    var $initiativeImageContainer = $('.initiative__images');

    console.log($initiativeImageColumn.width());
    console.log($initiativeImageContainer);
    

    function resizeInitiativeImageContainer() {
        $initiativeImageContainer.width(($initiativeImageColumn.outerWidth() - 60));
    }

    resizeInitiativeImageContainer();

    $(window).resize(function() {
        resizeInitiativeImageContainer();
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/initiatives.js